/**
 * Transform a string to all caps
 */

export default (Vue) => {
	Vue.filter('inv-uppercase', value => {
		return upperCase(value);
	});

	Vue.prototype.$invUppercase = value => {
		return upperCase(value);
	};

	/**
	 * Transform a string to all caps.
	 *
	 * @param {string} value
	 *
	 * @usage {{ str | inv-uppercase }}
	 *    'foo' => 'FOO'
	 */
	function upperCase(value) {
		if (! value) {
			return '';
		}

		return value.toString().toUpperCase();
	}
};